// var customFirstLoad = true;
// let customSessionId = 0;

// function matchesFilterTerm(title, term) {
//   const parts = term.split(" ").map(t => t.trim().toLowerCase());
//   const lowerTitle = title.toLowerCase();
//   return parts.every(p => {
//     const regex = new RegExp(p, "i");
//     return regex.test(lowerTitle);
//   });
// }

// function normalizeFilterTerm(value) {
//   return value.toLowerCase().replace(/&/g, "_");
// }

// function getCustomBaseUrl() {
//   const url = new URL(window.location.href);
//   url.searchParams.delete("page");
//   return url.toString();
// }

// document.addEventListener("DOMContentLoaded", function () {
//   const customFilters = document.querySelectorAll(".js-custom-term");
//   const productList = document.querySelector(".productgrid--items.non-ajaxinate-container");
//   const ajaxContainer = document.querySelector(".ajaxinate-container");

//   if (!customFilters.length) return;

//   const params = new URLSearchParams(location.search);
//   const selected = new Set(params.getAll("custom_filter").map(normalizeFilterTerm));

//   customFilters.forEach((li) => {
//     const val = normalizeFilterTerm(li.getAttribute("data-filter"));
//     if (selected.has(val)) {
//       li.classList.add("collection-filters__filter-list-item--active");
//     }
//   });

//   async function applyCustomFilter(clicked) {
//     customSessionId++;

//     let selectedFilters = [];
//     document
//       .querySelectorAll(".js-custom-term.collection-filters__filter-list-item--active")
//       .forEach((el) => {
//         selectedFilters.push(normalizeFilterTerm(el.getAttribute("data-filter")));
//       });

//     document.querySelector(".products-loading").classList.add("hide");

//     if (clicked) {
//       document.querySelector(".productgrid--wrapper")?.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }

//     if (selectedFilters.length === 0) {
//       if (customFirstLoad) {
//         customFirstLoad = false;
//         return;
//       }
//       productList.innerHTML = "";
//       productList.classList.add("hide");
//       ajaxContainer?.classList.remove("hide");
//       document.querySelector(".product-count.bottom")?.classList.remove("hide");
//       return;
//     }

//     productList.innerHTML = "";
//     document.querySelector(".products-loading").classList.remove("hide");
//     productList.classList.remove("hide");
//     ajaxContainer?.classList.add("hide");
//     document.querySelector(".product-count.bottom")?.classList.add("hide");

//     await loadCustomProducts(getCustomBaseUrl(), selectedFilters, 1, customSessionId);
//   }

//   async function loadCustomProducts(baseUrl, filters, page, sessionId) {
//     if (sessionId !== customSessionId) return;

//     let nextLink = null;
//     const urlObj = new URL(baseUrl, window.location.origin);
//     urlObj.searchParams.set("page", page);

//     try {
//       const res = await fetch(urlObj.toString());
//       if (!res.ok) return;

//       const text = await res.text();
//       const doc = new DOMParser().parseFromString(text, "text/html");

//       const products = [
//         ...doc.querySelectorAll(".productgrid--item, .grid__item, .card-wrapper")
//       ];

//       nextLink = doc.querySelector("a.paginate-next");

//       let matches = [];
//       if (filters.length > 0) {
//         matches = products.filter((p) => {
//           const title = p.getAttribute("data-title") || "";
//           return filters.some((f) => matchesFilterTerm(title, f));
//         });
//       } else {
//         matches = products;
//       }

//       if (sessionId !== customSessionId) return;

//       if (matches.length > 0) {
//         document.querySelector(".products-loading").classList.add("hide");
//       }

//       matches.forEach((p) => {
//         productList.appendChild(p);
//       });

//       if (nextLink && sessionId === customSessionId) {
//         setTimeout(() => {
//           loadCustomProducts(baseUrl, filters, page + 1, sessionId);
//         }, 300);
//       } else {
//         if (!productList.children.length) {
//           document.querySelector(".products-loading").classList.add("hide");
//           productList.innerHTML = `<p>No products found for selected filter options.</p>`;
//         }
//       }
//     } catch (err) {}
//   }

//   document.querySelectorAll(".js-custom-term").forEach((a) => {
//     a.addEventListener("click", function (e) {
//       e.preventDefault();
//       const parent = this.closest(".js-custom-term");
//       parent.classList.toggle("collection-filters__filter-list-item--active");
//       applyCustomFilter(true);
//     });
//   });

//   applyCustomFilter(false);
// });
// 


document.addEventListener("DOMContentLoaded", function () {
  const customFilters = document.querySelectorAll(".js-custom-term");
  const productListWrapper = document.querySelector(".productgrid--wrapper");

  // --- Extract tag filters from URL ---
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const selectedTagsFromUrl =
    pathParts.length > 2 ? pathParts[2].split("+") : [];

  const selectedNormalized = selectedTagsFromUrl.map((c) =>
    c.toLowerCase().replace(/\s+/g, "-")
  );

  // --- Highlight active filters ---
  customFilters.forEach((li) => {
    const val = li.getAttribute("data-filter")?.toLowerCase().replace(/\s+/g, "-");

    if (selectedNormalized.includes(val)) {
      li.classList.add("collection-filters__filter-list-item--active");
    }
  });

  // --- Tag click → update URL only ---
  document.querySelectorAll(".js-custom-term").forEach((filterEl) => {
    filterEl.addEventListener("click", function (e) {
      e.preventDefault();

      const filterValue = this.getAttribute("data-filter") || "";

      // Handle complex terms like “Black & White”
      const tagParts = filterValue
        .split("&")
        .map((t) => t.trim().toLowerCase().replace(/\s+/g, "-"))
        .filter(Boolean);

      // Extract collection handle from URL
      const pathParts = window.location.pathname.split("/").filter(Boolean);
      const collectionsIndex = pathParts.indexOf("collections");
      const collectionHandle = pathParts[collectionsIndex + 1] || "";

      // Scroll flag
      sessionStorage.setItem("scrollToProducts", "true");

      // Build new Shopify tag URL
      const newUrl = `/collections/${collectionHandle}/${tagParts.join("+")}`;
      window.location.href = newUrl;
    });
  });

  // --- Smooth scroll after reload ---
  if (sessionStorage.getItem("scrollToProducts") === "true") {
    sessionStorage.removeItem("scrollToProducts");

    setTimeout(() => {
      productListWrapper?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 600);
  }
});